import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import SectionTitle from "../common/section-title";
import ServiceBox from "./service-box";

class Services extends Component {
  state = {
    services: [
      {
        title: "Automate payroll processing",
        description:
          "Get up to 30% faster payroll by automating calculations.",
        variant: "payroll-dashboard",
      },
      {
        title: "Employee self-service portal",
        description:
          "Enable your team to access pay stubs, update info, and request time off.",
        variant: "employee-portal",
      },
      {
        title: "Automated tax compliance",
        description:
          "Stay compliant with automated tax filing and reporting templates.",
        variant: "tax-calculator",
      },
      {
  title: "Invoices and estimates",
  description:
    "Create professional invoices and estimates with itemized products, taxes, and PDF generation.",
  variant: "invoice-estimates",
},
      {
        title: "Comprehensive benefits admin",
        description:
          "Manage health insurance, 401(k) plans, and benefits enrollment seamlessly.",
        variant: "benefits-admin",
      },
      {
        title: "Real-time analytics dashboard",
        description:
          "Track labor costs and trends with powerful reporting tools and insights.",
        variant: "analytics-dashboard",
      },
      {
  title: "Professional check writer",
  description:
    "Write and print business checks with automatic check numbering and payment tracking.",
  variant: "check-writer",
},
      {
  title: "Multi-company management",
  description:
    "Manage multiple entities from one simple dashboard.",
  variant: "multi-company",
},
      {
  title: "Accounting reconciliation",
  description:
    "Reconcile payroll, bank transactions, and cash activity with built-in accounting tools.",
  variant: "reconciliation",
},
    ],
  };

  render() {
    return (
      <section className="pwlp-services-section" id="services">
        <Container>
          <SectionTitle
            title="Our Services"
            description="Comprehensive payroll and accounting solutions designed to streamline your business operations and ensure compliance."
          />

          <Row className="pwlp-services-grid">
            {this.state.services.map((service, key) => (
              <ServiceBox
                key={key}
                title={service.title}
                description={service.description}
                variant={service.variant}
              />
            ))}
          </Row>
        </Container>
      </section>
    );
  }
}

export default Services;


// import React, { Component } from "react";
// import { Container, Row } from "reactstrap";

// //Import Section Title
// import SectionTitle from "../common/section-title";

// //Import Service Box
// import ServiceBox from "./service-box";

// class Services extends Component {
//   state = {
//     services: [
//       {
//         title: "Payroll & Bookkeeping, Tailored for You",
//         icon: "pe-7s-diamond",
//         description:
//           "Whether you're a small business or growing enterprise, our tools adapt to your needs.",
//       },
//       {
//         title: "Seamless Employee Payroll Integration",
//         icon: "pe-7s-display2",
//         description:
//           "Manage employee pay rates, hours worked, PTO accrual, and tax withholdings all in one place.",
//       },
//       {
//         title: " Instant Access to Payroll Insights",
//         icon: "pe-7s-piggy",
//         description:
//           "Generate detailed payroll reports, tax summaries, and employee earnings with ease.",
//       },
//       {
//         title: "Flexible Payroll Solutions for Your Business",
//         icon: "pe-7s-science",
//         description:
//           "Choose pay schedules and deductions that fit your company’s needs.",
//       },
//       {
//         title: "Accurate & Efficient Payroll Calculations",
//         icon: "pe-7s-news-paper",
//         description:
//           "Our system ensures timely payroll processing with automated calculations and tax deductions.",
//       },
//       {
//         title: "Write & Print Checks Anytime",
//         icon: "pe-7s-plane",
//         description:
//           "Easily create and print checks for employees, vendors, or contractors—whenever you need them.",
//       },
//       {
//         title: "Data Security & Compliance",
//         icon: "pe-7s-arc",
//         description:
//           "Keep your payroll data safe with bank-level encryption and security protocols.",
//       },
//       {
//         title: "Organized & Accurate Financial Records",
//         icon: "pe-7s-tools",
//         description:
//           "Track your income, expenses, and transactions to maintain clear financial insights for your business.",
//       },
//       {
//         title: "Monitor & Categorize Business Expenses",
//         icon: "pe-7s-timer",
//         description:
//           "Stay on top of your cash flow by keeping track of business spending in real-time.",
//       },
//     ],
//   };
//   render() {
//     return (
//       <React.Fragment>
//         <section className="section bg-light" id="services">
//           <Container>
//             {/* Render section title */}
//             <SectionTitle
//               title="Our Services"
//               description="We provide efficient and reliable payroll solutions designed to streamline your business operations and ensure compliance."
//             />

//             <Row className="mt-5">
//               {/* render service box */}
//               {this.state.services.map((service, key) => (
//                 <ServiceBox
//                   key={key}
//                   title={service.title}
//                   icon={service.icon}
//                   description={service.description}
//                 />
//               ))}
//             </Row>
//           </Container>
//         </section>
//       </React.Fragment>
//     );
//   }
// }

// export default Services;
